import { render, staticRenderFns } from "./SessionSection.vue?vue&type=template&id=80e64bfe&"
import script from "./SessionSection.vue?vue&type=script&lang=ts&"
export * from "./SessionSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports